import React, { Fragment, Component } from "react";
import { translate } from "../Services/translation";
// import i18n from "../i18n";

const DefaultDecimalSeparator = ".";
const MaxQuantity = 9999;

class ProductQuantity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: this.props.quantity,
      showmessage: false,
      showalert:false
    };
    this.subtract = this.subtract.bind(this);
    this.add = this.add.bind(this);
    this.checkIsInStock = this.checkIsInStock.bind(this);
    this.quantityInputElement = undefined;
  }

  componentDidMount() {
    if (this.props.quantity) {
      if (this.props.isOutgoing == false) {
        this.setQuantityState(this.props.quantity);
      } else {
        if (this.props.quantity > this.props.availableQuantity) {
          this.setQuantityState(this.props.availableQuantity);
          this.setState({
            showmessage: true,
            showalert:true
          });
        }
      }
    }
  }
  componentDidUpdate() {
    if (this.props.quantity != this.state.quantity) {
      this.setQuantityState(this.props.quantity, false);
    }
  }

  setQuantityState(value, shouldCallback = true) {
    const fixedQuantity = Number(parseFloat(value).toFixed(2));
    this.setState({
      quantity: fixedQuantity,
    });
    this.quantityInputElement.value = fixedQuantity;
    // this.quantityInputElement.value = fixedQuantity.toLocaleString(i18n.locale);

    if (this.props.callbackParent && shouldCallback) {
      this.props.callbackParent(fixedQuantity);
    }
  }

  subtract() {
    const subtraction = 1;
    const newQuantity = this.state.quantity - subtraction;

    if (newQuantity > 0) {
      if (this.checkIsInStock(newQuantity) == true) {
        this.setQuantityState(newQuantity);
      }
    }
  }

  add() {
    const addition = 1;
    const newQuantity = this.state.quantity + addition;
    if (this.checkIsInStock(newQuantity) == true) {
      this.setQuantityState(newQuantity);
    }
  }
  checkIsInStock(newQuantity) {
    if (this.props.isOutgoing == false) {
      return true;
    }else{
      if (newQuantity > this.props.availableQuantity) {
        this.setState({
          showmessage: true,
          showalert:true
        });
        return false;
      } else {
        this.setState({
          showmessage: false,
          showalert:false
        });
        return true;
      }
    }
   
    
  }

  onQuantityInputElementBlur = () => {
    let normalizedInput = this.quantityInputElement.value
      .replace(",", DefaultDecimalSeparator) // Normalize decimal separator characters.
      .replace(/[^\d,\.]/, "") // Remove all characters except numericals or decimal separators.
      .trim();
    let quantity = parseFloat(normalizedInput);

    if (this.props.unitDecimalDigits === 0) {
      // Product sold in pieces
      quantity = parseInt(quantity.toFixed(0));
    }

    if (isNaN(quantity) || quantity <= 0) {
      // Revert to existing state.
      this.quantityInputElement.value = this.state.quantity;
      return;
    }

    if (quantity > MaxQuantity) {
      quantity = MaxQuantity;
    }
    if (this.checkIsInStock(quantity)) {
      this.setQuantityState(quantity);
    } else {
      this.setQuantityState(this.props.availableQuantity);
    }
  };

  onQuantityInputElementKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.quantityInputElement.blur();
    }
  };

  render() {
    const { inputId, unit, minimumQuantity } = this.props;
    const { quantity } = this.state;

    // const localizedMinimuQuantityString = minimumQuantity.toLocaleString(i18n.locale);

    return (
      <Fragment>
        <div className="product-detail__quantity-container">
          <button
            className="product__quantity-button"
            onClick={() => this.subtract()}
          >
            -
          </button>
          <div className="product__buy-quantity-container">
            <input
              id={inputId}
              type="number"
              defaultValue={quantity}
              onBlur={this.onQuantityInputElementBlur}
              onKeyDown={(event) => this.onQuantityInputElementKeyDown(event)}
              ref={(element) => (this.quantityInputElement = element)}
              data-buy-quantity-input
              min={minimumQuantity}
              step="any"
              maxLength="9"
              className="cart__input product-detail__quantity-input form__input"
            />
            {unit && (
              <label htmlFor={inputId} className="product__unit">
                {unit}
              </label>
            )}
          </div>
          <button
            className="product__quantity-button"
            onClick={() => this.add()}
            disabled={this.state.showmessage}
          >
            +
          </button>
        </div>
        {this.state.showalert == true && (
          <div className="product__quantity-validation">
            {translate("availablequantity.errormessage")}{" "}
            {this.props.availableQuantity}
          </div>
        )}
      </Fragment>
    );
  }
}

export default ProductQuantity;
